import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  HeroContainer,
} from './styled'

const CommunityHeader = ( { background } ) => {

  return (
    <Container>
      <HeroContainer elevation={0} background={background}>
        {/* Content for the Hero section */}
      </HeroContainer>
    </Container>
  )
}

CommunityHeader.propTypes = {
  background: PropTypes.string,
}

export default CommunityHeader
